<template>
    <header id="layout-header" class="header">
            <div class="d-flex">
              <img class="company-logo" src="/static/images/vtclogo.png" alt="logo" width="200" height="44">
              <div class="header-title">Territory Mapping</div>
            </div>
            <img class="banner-img" src="/static/images/banner-img.png" alt="logo" width="auto" height="120">

    </header>
</template>

<script>

    import Vue from 'vue';
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    var self;

    export default {
        name: 'Front-Header',
        components: {
        },
        data() {
            return {

            }
        },

        beforeMount: function () {
            self = this;
        },
        mounted: function () {
        },
        methods: {
        },
    }
</script>
<style scoped>
img {
    max-width: 100%;
    height: auto;
}
.wrapper{
    border:2px solid #E8EAED;
    margin-top: 20px;
}
header{
    min-height: 120px;
    background-color: #D3EAFF;
    position: relative;
}
header img.banner-img{
    position: absolute;
    top: 0;
    right: 0;
    height:120px;
}
header img.company-logo{
    padding-top: 40px;
    margin-left: 30px;
}
header .header-title{
    margin-left: 30px;
    font-size: 28px;
    margin-top: 35px;
}
.territory-page ul{
    padding: 20px 0 20px 20px;
    list-style: none;
    margin: 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}
.territory-page ul li{
    display: inline-block;
    line-height: 40px;
    margin: 0 3px 10px;
}
.territory-page ul li:last-child{
    margin-right: 0;
}
.territory-page ul li a{
    border: 1px solid #08172B;
    border-radius: 11px;
    display: block;
    min-width: 140px;
    text-align: center;
}
.territory-page .postal-code{
    background-color: #f8f8f8;
    padding: 10px;
    height: 100%;
    display: flex;
    justify-content: space-between;
}
.territory-page .postal-code input[type=text]{
    border: 0;
    border-bottom: 2px solid #707070;
    background: transparent;
    height: 48px;
    width: 100%;
}
.territory-page .postal-code .search-btn{
    background: #fff;
    border: 1px solid #08172B;
    border-radius: 34px;
    width: 150px;
    height: 60px;
}
@media(max-width:823px){
    header{
        min-height: initial;
    }
    header .header-title{
        padding-bottom: 20px;
    }
    header img.banner-img{
        width: 50%;
    }
    header img.company-logo{
        padding-top: 20px;
        margin-left: 12px;
        width: 45%;
        max-width: 200px;
    }
    .territory-page ul{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 20px 0 20px 0;
    }
    .territory-page ul li a{
        min-width: 120px;
    }
    .territory-page ul li{
        margin: 0 3px 10px;
    }
    .territory-page .postal-code input[type=text]{
        min-width: initial;
        height: 40px;
        width: 100%;
    }
    .territory-page .postal-code .search-btn{
        height: 45px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Front-Header.vue